import { group } from 'console'
import Api from 'services/Api'
import { GroupDoc } from 'types/api/changes'
import { extractDeepLinkCode } from 'utils/deeplink'

export async function generateDeepLink(
  request: GenerateDeepLinkRequest,
  groupId: string
): Promise<GroupDoc> {
  const update = await Api.post(`/v1/groups/${groupId}/deeplink`, {
    ...request
  })
  return update.data
}

export async function disableDeepLink(groupId: string): Promise<GroupDoc> {
  return (await Api.delete(`/v1/groups/${groupId}/deeplink`)).data
}

export interface GenerateDeepLinkRequest {
  PrivateLinkPassword: string
}

export interface GenerateDeepLinkResponse {
  Link: string
  Code: string
}
